export default ({ isDev }, inject) => {
    inject('isDev', () => isDev);
}